export default (dispatch) => ({
  applyFilters: (sortMethod, featureFilter) => {
    dispatch({
      type: 'features/setIsSortingItems',
      payload: true,
    });
    setTimeout(() => {
      dispatch({
        type: 'features/sortFeatures',
        payload: sortMethod
      });
    }, 50)
  },
  resetFilters: () => {
    dispatch({
      type: 'features/resetFiltersAndSort'
    });
    dispatch({
      type: 'features/getUserDataPoll-start',
      callback: () => {
        dispatch({
          type: 'features/getUserDataPoll-stop',
        });

        dispatch({
          type: 'features/setMoreFeaturesLoading',
          payload: false
        });
      }
    });
  }
});
